import styled from 'styled-components';
import media from 'components/mixins/media';
import { bodyBackground } from 'components/mixins/backgrounds';
import { PageSidebar, PageContent } from 'components/shell/Layout';
import { transparentize } from 'utils/color';
import { centerAbsoluteElement } from 'components/mixins/placement';
import Text from 'components/common/Text';
import { secondaryFont } from 'components/mixins/typography';

export const LoginPageSidebar = styled(PageSidebar)`
  position: absolute;
  top: 0;
  left: 0;
  width: 50%;
  height: 100%;
  overflow-y: auto;
  background-color: ${props =>
    props.background.header.coverOverlay.enabled
      ? transparentize(
          props.background.header.coverOverlay.color,
          props.background.header.coverOverlay.opacity
        )
      : null};
`;

export const LoginPageContent = styled(PageContent)`
  position: absolute;
  top: 0;
  left: 50%;
  height: 100%;
  width: 50%;
  left: 50%;
  z-index: 100;
  overflow-y: auto;
  ${props => bodyBackground(props.background.body)};
  ${media.tablet`
    position: relative;
    width: 100%;
    left: 0;
  `};
`;

export const LoginSection = styled.section`
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  padding: 40px 0;
`;

export const LoginContainer = styled.div`
  width: 300px;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  ${media.mobile`
    width: 260px;
  `};
`;

export const CourseLogo = styled.img.attrs({
  alt: props => props.altText,
  src: props => props.logoUrl
})`
  display: none;
  margin: 56px auto;
  max-width: 200px;
  max-height: 80px;

  ${media.tablet`
    display: block;
  `};
`;

export const CourseLogoSidebar = styled.img.attrs({
  alt: props => props.altText,
  src: props => props.logoUrl
})`
  display: block;
  max-width: 100%;
  max-height: 100%;
  margin: 0 auto;
`;

export const CourseLogoSidebarWrapper = styled.div`
  width: 360px;
  height: 200px;
  position: absolute;
  ${centerAbsoluteElement};
`;

export const FormLabel = styled.label`
  ${secondaryFont};
  display: inline;
  font-size: 36px;
  font-weight: 200;
  line-height: 1.03;
  text-align: center;
  color: ${props => props.theme.colors.textColor};
  margin-top: 100px;

  ${media.tablet`
    margin-top: 0;
  `};
`;

export const TextForm = styled(Text)`
  ${secondaryFont};
  font-size: 14px;
  text-align: center;
  font-weight: normal;
  margin: 32px auto;
  color: ${props => transparentize(props.theme.colors.textColor, 0.5)};
  width: 300px;
  ${media.mobile`
    width: 220px;
  `};
`;

export const SocialLoginContainer = styled.div`
  position: relative;
  width: 320px;
  margin-bottom: 40px;
`;

export const SkipLinkContainer = styled.div`
  margin-top: 25px;
`;

export const SwitcherFormContainer = styled.div`
  ${media.tablet`
    display: none;
  `};
  ${media.mobile`
    display: none;
  `};
`;
